import React from "react";
import { Modal, Row, Col, Typography, Divider, Button, Checkbox } from "antd";
import { Colors } from "theme";

const { Title, Text } = Typography;
export default function CustomiseModal({
  isModalVisible,
  handleOk,
  handleCancel,
  customiseColumns,
  handleChange,
  handleDone,
  category
}) {
  return (
    <Modal
      centered
      footer={null}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      bodyStyle={{ padding: "2rem" }}
    >
      <Row>
        <Col>
          <Title level={4} style={{ fontFamily: "Gilroy", margin: 0 }}>
            {" "}
            Select the fields you want to share for {category?.name}
          </Title>
          <Text type="secondary">
            Only the data for selected fields will be shared with the buyer
          </Text>
        </Col>
      </Row>
      <Divider />
      <Row >
        {customiseColumns &&
          customiseColumns.map(
            (col,index) =>
              col.dataIndex !== "product_id" &&
              col.dataIndex !== "image" &&
              col.dataIndex !== "isSelected" &&
              col.dataIndex !== "deleteId"  &&
              col?.is_internal !== true
              && (
                <Col span={12} key={index} style={{ marginTop: "1rem" }}>
                  <Checkbox
                    checked={col?.visible}
                    onChange={(e) => {
                      // col.visible = !col.visible;
                      handleChange(e, col);
                    }}
                  >
                   <Text type="secondary"> {col?.type ==="price" ? col?.dataIndex:col?.title}</Text>
                   
                  </Checkbox>
                </Col>
              )
          )}
      </Row>

      <Row justify="space-between" style={{ marginTop: "2rem" }}>
        <Col span={8}>
          <Button
            style={{ width: "100%" }}
            size="large"
            onClick={() => handleCancel()}
          >
            Cancel
          </Button>
        </Col>
        <Col span={8}>
          <Button
            size="large"
            style={{
              background: Colors.black,
              color: Colors.white,
              width: "100%",
              border: "none",
            }}
            onClick={() =>handleDone(category) }
          >
            Done
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}
